import { render } from "./DashboardControl.vue?vue&type=template&id=9d7b2156&scoped=true"
import script from "./DashboardControl.vue?vue&type=script&lang=js"
export * from "./DashboardControl.vue?vue&type=script&lang=js"

import "./DashboardControl.vue?vue&type=style&index=0&id=9d7b2156&lang=scss&scoped=true"
import "./DashboardControl.vue?vue&type=style&index=1&id=9d7b2156&lang=scss"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d7b2156"]])

export default __exports__